/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-styled */
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export const QuickCardContainer = styled.div<{
	isDisabled: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& button': {
		borderRadius: '3px',
		alignItems: 'center',
		padding: `${token('space.200')} ${token('space.150')}`,
	},
});

export const ButtonText = styled.div<{
	isDisabled: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) => (props.isDisabled ? token('color.text.disabled') : token('color.text.subtle')),
	font: token('font.body'),
	fontWeight: token('font.weight.regular'),
});

export const QuickCardIcon = styled.div<{ isDisabled: boolean }>({
	width: '24px',
	height: '24px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	opacity: (props) => (props.isDisabled ? '0.4' : '1'),
	/**
	 * New atlaskit icons have additional padding when placed inside a button,
	 * but this won't match up with existing old icons.
	 * Unsetting the padding to keep paddings consistent without having to add a
	 * duplicate icon / adjust other BPQA icons.
	 */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& span': {
		paddingInlineStart: 'unset',
		paddingInlineEnd: 'unset',
	},
});

export const QuickCardColumn = styled.div({
	flexDirection: 'column',
	display: 'flex',
});

export const BlankPageQuickActionsCardContainer = styled.div<{
	isTemplatesPanelOpen: boolean;
	shouldAdjustForContextPanel: boolean;
}>({
	flexDirection: 'column',
	display: 'flex',
	bottom: token('space.300'),
	padding: token('space.200'),
	border: `1px solid ${token('color.border')}`,
	gap: token('space.150'),

	borderRadius: token('space.100'),
	backgroundColor: token('elevation.surface'),
	zIndex: '2',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginRight: ({ isTemplatesPanelOpen, shouldAdjustForContextPanel }) =>
		isTemplatesPanelOpen && shouldAdjustForContextPanel ? '-320px' : '0px',
});

export const BlankPageQuickActionsWrapper = styled.div({
	display: 'flex',
	width: 'auto',
	justifyContent: 'center',
	padding: token('space.200'),
	paddingBottom: token('space.250'),
	position: 'absolute',
	bottom: '0px',
});

export const BlankPageQuickActionsTemplatePreviewWrapper = styled.div({
	display: 'flex',
	width: '100%',
	justifyContent: 'center',
	position: 'relative',
	backgroundColor: token('elevation.surface'),
});

export const Link = styled.div<{ isActive: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& button': {
		borderRadius: '3px',
		alignItems: 'center',
		padding: `${token('space.200')} ${token('space.150')}`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& button:not(:hover)': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: ({ isActive }) =>
			isActive
				? `${token('color.background.neutral.subtle.pressed')} !important`
				: 'transparent !important',
	},
});

export const BlankPageQuickActionsTemplatePreviewContainer = styled.div<{
	shouldShowTemplatePreview: boolean;
	editorWidth: number;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	display: ({ shouldShowTemplatePreview }) => (shouldShowTemplatePreview ? 'auto' : 'none'),
	position: 'absolute',
	// As editor width shrinks, we need to have the overlay higher up to account
	// for the placeholder as it wraps. As the placeholder wraps to multiple lines,
	// the template preview overlay no longer covers it, removing the appearance of
	// an "in-editor" preview.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	top: ({ editorWidth }) => (editorWidth < 500 ? '-110px' : editorWidth < 820 ? '-80px' : '-60px'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingBottom: '120px',
	backgroundColor: token('elevation.surface'),
	width: '100%',
	zIndex: '1',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& *': {
		pointerEvents: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		height: 'auto',
		minHeight: token('space.500'),
		backgroundColor: token('elevation.surface'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& [data-testid="template-preview-scroll-wrapper"]': {
		transform: 'unset',
		width: '100%',
		padding: '0px',
		backgroundColor: token('elevation.surface'),
		// this targets the wrapper around the renderer which is what sets its padding
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'& div:has(.ak-renderer-document)': {
			paddingLeft: '0px',
			paddingRight: '0px',
			marginLeft: '0px',
			marginRight: '0px',
			maxWidth: 'unset',
		},
	},
});
